<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    :options="options"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="popup-history"
  >
    <template v-slot:title>
      <!-- [S]  Popup title-->
      <v-card-title class="headline white--text" primary-title>{{
        $t('lbl.dbMapperManager.versionHistory.header')
      }}</v-card-title>
      <!-- [E]  Popup title-->
    </template>
    <template v-slot:button-close>
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <v-card class="analyzed-dialog matched-map-list-dialog">
      <!-- [S]  Popup top text-->
      <v-card-text class="ml-4 pa-0 popup-title">
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0">
            <span class="title-file-name--text">{{ options.item.data.mapper_name }}</span>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [S]  Popup top text-->

      <!-- [S]  Popup top buttons-->
      <v-card-text class="top-btn-display-m">
        <v-row class="ma-0 mb-2">
          <v-col cols="12" class="pa-0">
            <v-btn
              class="mr-4 btn btn-popup-search float-right"
              color="primary"
              tile
              @click="openCheckIn"
              :disabled="itemToCheckIn.lock_yn != 'Y'"
            >
              {{ $t('btn.dbMapperManager.checkIn') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Popup top buttons-->

      <!-- [S]  Popup body-->
      <v-card-text class="content-version-section">
        <v-row class="content-covering-m pt-0">
          <v-col cols="12" class="pa-0">
            <v-row class="version-history-table ma-0">
              <v-col cols="12" class="pa-0">
                <v-data-table
                  :items="versionList"
                  :hide-default-footer="true"
                  :fixed-header="true"
                  class="analyzed-layout-table"
                  disable-pagination
                  disable-sort
                  :height="customHeight"
                >
                  <template v-slot:body="{ items }">
                    <thead>
                      <tr>
                        <th class="text-center text-version" style="width:51px">
                          {{ $t('tbl.dbMappeManager.versionHistory.ver') }}
                        </th>
                        <th class="text-center text-version" colspan="2" style="width:117px">
                          {{ $t('tbl.dbMappeManager.versionHistory.select') }}
                        </th>
                        <th class="text-center text-version" style="width:133px">
                          {{ $t('tbl.dbMappeManager.versionHistory.date') }}
                        </th>
                        <th class="text-center text-version">
                          {{ $t('tbl.dbMappeManager.versionHistory.user') }}
                        </th>
                        <th class="text-center text-version">
                          {{ $t('tbl.dbMappeManager.versionHistory.changeHistory') }}
                        </th>
                        <th class="text-center text-version" style="width:60px">
                          {{ $t('tbl.dbMappeManager.versionHistory.delete') }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in items" :key="item.id">
                        <td class="text-center text-bold">{{ item.mapper_ver }}</td>
                        <td
                          v-if="item.mapper_current === 'Y'"
                          class="text-left  align-radio"
                          style="width:29px"
                        >
                          <input
                            type="radio"
                            v-model="item.mapper_current"
                            :value="item.mapper_current"
                            name="matched-map"
                            @click="selectVersion(item)"
                          />
                        </td>
                        <td
                          v-if="item.mapper_current === 'N'"
                          class="text-left  align-radio"
                          style="width:29px"
                        >
                          <input type="radio" name="matched-map" @click="selectVersion(item)" />
                        </td>
                        <td class="text-left" style="width:87px">
                          <a @click="openCheckOut(item)">{{
                            $t('tbl.dbMappeManager.versionHistory.checkOut')
                          }}</a>
                        </td>
                        <td class="text-left">{{ item.dep_dt }}</td>
                        <td class="text-left text-bold">{{ item.cre_usr_id }}</td>
                        <td class="text-left">{{ item.mapper_comment }}</td>
                        <td class="text-center">
                          <v-btn
                            v-if="
                              item.mapper_current === 'Y' ||
                                item.mapper_ver === currentVerItems.mapper_ver
                            "
                            small
                            disabled
                            text
                            icon
                          >
                            <icon-svg :disabled="true" iconName="delete" />
                          </v-btn>
                          <v-btn v-else small text icon @click="deleteItem(item)">
                            <icon-svg iconName="delete" />
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                  <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">{{ $t('btn.common.reset') }}</v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Popup body-->
      <v-divider class="ml-0 mr-0 mt-2 divder-popup" inset></v-divider>
      <v-row class="ml-0 mr-0">
        <v-col class="button-col action-col" lg="12">
          <div class="btn-form-control text-right mr-4">
            <v-btn class="btn btn-delete btn-popup" @click="removeDialog">{{
              $t('btn.common.close')
            }}</v-btn>
            <v-btn
              class="btn btn-popup-search btn-popup"
              color="primary"
              tile
              @click="saveVersionHistory"
              :disabled="itemToCheckIn.lock_yn != 'Y'"
            >
              {{ $t('btn.common.save') }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <dialogWindow
      ref="deleteDialog"
      size="max"
      :detail="$t('msg.common.infoConfirm.detail', ['delete the DB Mapper version'])"
      color="confirmation"
      :show-cancel="true"
      @select-ok="onClickDelete"
    ></dialogWindow>
    <dialogWindow
      ref="checkOutDialog"
      size="max"
      :detail="$t('msg.common.warning.detailOkConfirm')"
      color="confirmation"
      :show-cancel="true"
      @select-close="onClickCancel"
      @select-ok="onClickOkay"
    >
    </dialogWindow>
    <dialogWindow
      ref="warningDialog"
      size="max"
      :detail="$t('msg.common.warning.detailWarningCheckIn')"
      color="warning"
    >
    </dialogWindow>
    <dialogWindow
      ref="successDialog"
      size="max"
      title="Success"
      color="success"
      @select-ok="removeDialog"
      :detail="$t('msg.dbMapperManager.deployMapper.deploySuccess')"
    ></dialogWindow>
    <dialogWindow
      ref="checkDialog"
      size="max"
      :detail="$t('msg.common.warning.detailWarningDuplicationCheckOut')"
      color="confirmation"
    >
    </dialogWindow>
  </dialog-drag>
</template>

<script>
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import { showProgress, hideProgress } from '@/vue-dlb/utils/sys-util.js';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';

export default {
  components: {
    DialogDrag,
    dialogWindow,
    IconSvg,
  },
  props: {
    id: String,
    options: Object,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
  },
  data() {
    return {
      versionList: [],
      oldVersion: '',
      currentVerItems: {},
      seletedDelete: {},
      customHeight: 61,
      onSave: false,
      checkOutDialog: false,
      lockedFlag: false,
      fileId: null,
      moveData: null,
      itemToCheckIn: {},
    };
  },
  watch: {
    'options.item.data.mapper_id'() {
      this.queryList();
    },
  },
  methods: {
    deleteItem(item) {
      this.seletedDelete = item;
      this.$refs.deleteDialog.dialog = true;
    },
    onClickDelete() {
      if (this.onSave) return;
      showProgress();
      this.onSave = true;
      this.$store
        .dispatch('deleteDBAdapterMapperHistory', {
          mapper_id: this.options.item.data.mapper_id,
          mapper_ver: this.seletedDelete.mapper_ver,
        })
        .then(() => {
          this.queryList();
          this.versionList = this.$store.getters.dbAdapterMapperHistoryList;
          this.currentVerItems = this.versionList.find((e) => e.mapper_current === 'Y');
          this.oldVersion = this.currentVerItems.mapper_ver;

          let len = this.versionList.length;
          this.customHeight = (len > 6 ? 6 : len) * 35 + (this.$vuetify.theme.dark ? 26 : 40);
          hideProgress();
          this.onSave = false;
        })
        .catch(() => {
          hideProgress();
          this.onSave = false;
        });
    },
    openCheckOut(item) {
      // if (item.lock_yn === 'N') {
      this.fileId = item;
      this.$refs.checkOutDialog.dialog = true;
      // }
      // else this.$refs.checkDialog.dialog = true;
    },
    onClickOkay() {
      Store.dispatch('dbAdapterMapperCheckOut', { mapper_id: this.fileId.mapper_id }).then(() => {
        this.lockedFlag = true;
        this.$emit('refreshMapList');
        EventBus.$emit('updateDBMapperContent', this.fileId);
      });
    },
    onClickCancel() {
      EventBus.$emit('updateDBMapperContent', this.fileId);
    },
    selectVersion(item) {
      this.currentVerItems = item;
    },
    openCheckIn() {
      if (this.itemToCheckIn.lock_yn === 'N' && this.lockedFlag === false) {
        this.$refs.warningDialog.dialog = true;
        return;
      }
      if (this.itemToCheckIn.mapper_check_in_user == this.$cookies.get('user-id')) {
        // this.$emit("openDeployXmlMapper", this.options.item.data);
        this.$store.dispatch('deployDBMapperAdapter', this.options.item.data).then((response) => {
          this.$refs.successDialog.dialog = true;
          this.$emit('refreshMapList');
        });
      } else this.$refs.warningDialog.dialog = true;
    },
    queryList() {
      showProgress();
      this.$store
        .dispatch('dbAapterMapperHistory', {
          mapper_id: this.options.item.data.mapper_id,
        })
        .then(() => {
          this.versionList = this.$store.getters.dbAdapterMapperHistoryList;
          this.currentVerItems = this.versionList.find((e) => e.mapper_current === 'Y');
          this.oldVersion = this.currentVerItems.mapper_ver;

          let len = this.versionList.length;
          this.customHeight = (len > 6 ? 6 : len) * 35 + (this.$vuetify.theme.dark ? 26 : 40);
          hideProgress();
        })
        .catch(() => {
          hideProgress();
        });
    },
    saveVersionHistory() {
      showProgress();
      if (this.itemToCheckIn.mapper_check_in_user == this.$cookies.get('user-id')) {
        this.$store
          .dispatch('changeDbAdapterMapperVersionHistory', this.currentVerItems)
          .then(() => {
            this.$emit('refreshMapList');
            hideProgress();
            this.$refs.successDialog.dialog = true;
          })
          .catch(() => {
            hideProgress();
          });
      } else this.$refs.warningDialog.dialog = true;
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
      // EventBus.$emit("refreshMapList");
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
  },
  created() {
    this.itemToCheckIn = this.options.item.data;
    this.queryList();
  },
};
</script>

<style></style>
